import { styled } from 'src/ui/theme'

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
